module.exports = __webpack_public_path__ + "img/bitshake-ip.e9cb9256.png";